var _text, _g, _circle, _circle2, _circle3, _circle4, _circle5, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyncroLogoColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -8 270 88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "textGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4F46E5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#7C3AED",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#EC4899",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4F46E5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#7C3AED",
      stopOpacity: 1
    }
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 55,
    fontFamily: "Arial, sans-serif",
    fontSize: 56,
    fontWeight: 700,
    fill: "url(#textGradient)",
    textAnchor: "middle"
  }, "Syncro")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 8,
    fill: "url(#iconGradient)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -12,
    cy: 15,
    r: 8,
    fill: "url(#iconGradient)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 8,
    fill: "url(#iconGradient)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: -12,
    y2: 15,
    stroke: "url(#iconGradient)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 12,
    y2: 15,
    stroke: "url(#iconGradient)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: -12,
    y1: 15,
    x2: 12,
    y2: 15,
    stroke: "url(#iconGradient)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -3 7.5 L 0 4 L 3 7.5 L 0 11 Z",
    fill: "url(#iconGradient)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 70,
    r: 3,
    fill: "#4F46E5",
    opacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 70,
    r: 3,
    fill: "#7C3AED",
    opacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 70,
    r: 3,
    fill: "#A855F7",
    opacity: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 70,
    r: 3,
    fill: "#C026D3",
    opacity: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 70,
    r: 3,
    fill: "#EC4899",
    opacity: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 70,
    x2: 200,
    y2: 70,
    stroke: "url(#textGradient)",
    strokeWidth: 1.5,
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncroLogoColor);
export default __webpack_public_path__ + "static/media/syncro_logo_color.d6bc4f666aeafc422266db962be3f840.svg";
export { ForwardRef as ReactComponent };